export default {"src":"/_next/static/media/503.00c173ef.svg","height":656,"width":1200,"blurWidth":0,"blurHeight":0};